import PatentModule from './PatentModule'
import NoticeCenter from './NoticeCenter'
import TrademarkModule from './TrademarkModule'
import CopyrightModule from './CopyrightModule'
import ConfirmCenter from './ConfirmCenter'
import Bill from './Bill'
import Briefcase from './Briefcase'
export default [
    {
        name: 'PatentModule',
        path: 'PatentModule',
        component: () => import('@/pages/BigData/PatentModule/index'),
        meta: { title: '专利代报' ,requiresAuth: true},
        props(route) {
            return {id: route.query.id};
        },
        children: [...PatentModule]
    },
    {
        name: 'TrademarkModule',
        path: 'TrademarkModule',
        redirect:{name:'TmAll'},
        component: () => import('@/pages/BigData/TrademarkModule/index'),
        meta: { title: '商标代报', requiresAuth: true},
        props(route) {
            return {id: route.query.id}
        },
        children: [...TrademarkModule]
    },
    {
        name: 'CopyrightModule',
        path: 'CopyrightModule',
        redirect:{name:'BanquanRegist'},
        component: () => import('@/pages/BigData/CopyrightModule'),
        meta: { title: '版权代报' ,requiresAuth: true},
        props(route) {
            return {id: route.query.id}
        },
        children: [...CopyrightModule]
    },
    {
        name: 'Briefcase',
        path: 'Briefcase',
        redirect: { name: 'MyFiles' },
        component: () => import('@/pages/BigData/Briefcase'),
        meta: { title: '公文包' ,requiresAuth: true},
        props(route) {
            return {id: route.query.id}
        },
        children: [...Briefcase]
    },
    {
        name: 'NoticeCenter',
        path: 'NoticeCenter',
        redirect: { name: 'AllNote' }, // 重定向到指定名称的路由,
        component: () => import('@/pages/BigData/NoticeCenter'),
        meta: { title: '通知中心',requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        },
        children: [...NoticeCenter]
    },
    {
        name: 'ConfirmCenter',
        path: 'ConfirmCenter',
        component: () => import('@/pages/BigData/ConfirmCenter'),
        meta: { title: '需确认材料' ,requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        },
        children: [...ConfirmCenter]
    },
    {
        name: 'Bill',
        path: 'Bill',
        component: () => import('@/pages/BigData/Bill'),
        meta: { title: '账单' ,requiresAuth: true },
        props(route) {
            return {id: route.query.id}
        },
        children: [...Bill]
    },
]